import React, { useState } from "react";
import classNames from "classnames";
import { clearAuthData, getUserData, hasRole } from "../auth";

// Import Components
import CustomerOrders from "./oders/CustomerOrders";
import ProcessedOrders from "./oders/ProcessedOrders";

import FailedCustomerOrders from "./oders/FailedCustomerOrders";
import SuccessfulCustomerOrders from "./oders/SuccessfulCustomerOrders";

// Import MUI Icons
import MenuIcon from "@mui/icons-material/Menu"; // Mobile menu icon
import CloseIcon from "@mui/icons-material/Close"; // Close icon
 import ErrorIcon from "@mui/icons-material/Error"; // Failed Customer Orders icon
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser"; // Successful Customer Orders icon
import { useNavigate } from "react-router-dom";
import { LogoutOutlined } from "@mui/icons-material";
 import CheckCircleIcon from '@mui/icons-material/CheckCircle';
 import { orange, blue, red, green, purple, teal } from '@mui/material/colors';
 import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StoreIcon from '@mui/icons-material/Store';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useGetPendingCartCountBySellerQuery } from "../apis/OrderAPi";
import { Box, Typography } from "@mui/material";
const OrderViewAmazonVendor = () => {
  // Retrieve user data and roles
  const userData = getUserData();
  const sellerId = userData?.uid || "";
  const roles = userData?.role || [];
  const navigate = useNavigate();

   const isVendor = hasRole('ROLE_VENDER'); // Check if the user has the 'vendor' role
  
     // Only execute the query if the user is a vendor
     // Call the hook unconditionally, but use `skip: true` when not a vendor
    const { data: count } = useGetPendingCartCountBySellerQuery(sellerId, {
      pollingInterval: 5000,
      skip: !isVendor, // Skip query if not a vendor
    });
 
  
 //console.log('count value',count);
  // State to track the active tab
  const [activeTab, setActiveTab] = useState("CustomerOrders");
  const [isSidebarActive, setIsSidebarActive] = useState(false);

  // Helper variables for role-based access
  const canAccessVendorFeatures = roles.some((role) =>
    ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)
  );

  const handleLogout = () => {
    clearAuthData();
    navigate("/account"); // Redirect to login page
  };

  // Tab configuration with icons
  const tabsOld = [
   
    {
      id: "CustomerOrders",
      label: "Pending Customers Orders",
      icon: <AssignmentTurnedInIcon sx={{ marginRight: 1 }} />,
      component: <CustomerOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "processedOrders",
      label: "Processed Customers Orders",
      icon: <CheckCircleIcon sx={{ marginRight: 1 }} />,
      component: <ProcessedOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "FailedCustomerOrders",
      label: "Failed Customers Orders",
      icon: <ErrorIcon sx={{ marginRight: 1 }} />,
      component: <FailedCustomerOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "SuccessfulCustomerOrders",
      label: "Successful Customers Orders",
      icon: <VerifiedUserIcon sx={{ marginRight: 1 }} />,
      component: <SuccessfulCustomerOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "Logout", // 🚀 Logout Tab
      label: "Logout",
      icon: <LogoutOutlined sx={{ marginRight: 1 }} />,
      component: null,
      condition: true,
      action: handleLogout, // Trigger logout on click
    },
  ];

  const tabs = [
    {
      id: "Home",
      label: "Home",
      icon: <HomeIcon sx={{ color: purple[500], marginRight: 1 }} />, // 🏠 Purple for Home
      component: null,
      condition: true,
      action: () => navigate('/'),
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: <DashboardIcon sx={{ color: teal[500], marginRight: 1 }} />, // 📊 Teal for Dashboard
      component: null,
      condition: true,
      action: () => navigate('/dashboard-vendor'),
    },
    {
      id: "Wallet",
      label: "Wallet",
      icon: <AccountBalanceWalletIcon sx={{ color: orange[600], marginRight: 1 }} />, // 💰 Orange for Wallet
      component: null,
      condition: true,
      action: () => navigate('/wallet'),
    },
    {
      id: "MyStore",
      label: "My Store",
      icon: <StoreIcon sx={{ color: green[600], marginRight: 1 }} />, // 🏬 Green for Store
      component: null,
      condition: true,
      action: () => navigate('/shop'),
    },
    {
      id: "CustomerOrders",
      label: (
        <span style={{ display: "flex", alignItems: "center" }}>
                  <AssignmentTurnedInIcon sx={{ color: orange[500], marginRight: 1 }} />
                  <Typography variant="body1" sx={{ marginRight: 2 }}>
         Pending Customers Orders
       </Typography>
                   {/* Count Badge */}
                  <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs">
                    {count ?? 0} {/* Display count */}
                </span>
              </span>
     ),
      component: <CustomerOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "processedOrders",
      label: "Processed Customers Orders",
      icon: <CheckCircleIcon sx={{ color: blue[500], marginRight: 1 }} />, // 🔵 Blue for processed
      component: <ProcessedOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "FailedCustomerOrders",
      label: "Failed Customers Orders",
      icon: <ErrorIcon sx={{ color: red[500], marginRight: 1 }} />, // ❌ Red for failed
      component: <FailedCustomerOrders />,
      condition: canAccessVendorFeatures,
    },
    {
      id: "SuccessfulCustomerOrders",
      label: "Successful Customers Orders",
      icon: <VerifiedUserIcon sx={{ color: green[500], marginRight: 1 }} />, // ✅ Green for success
      component: <SuccessfulCustomerOrders />,
      condition: canAccessVendorFeatures,
    },
    
    {
      id: "Logout", // 🚪 Logout Tab
      label: "Logout",
      icon: <LogoutOutlined sx={{ color: red[400], marginRight: 1 }} />, // 🔴 Red for logout
      component: null,
      condition: true,
      action: handleLogout, // Trigger logout on click
    },
  ];


  const sidebarController = () => {
    setIsSidebarActive(!isSidebarActive);
  };

  return (
    <section className="contact py-80">
      <div
        className={`side-overlay ${isSidebarActive && "show"}`}
        onClick={sidebarController}
      ></div>
      <div className="container container-lg">
        <div className="row">
          {/* Sidebar Start */}
          <div className="col-lg-3">
            <div className={`shop-sidebar ${isSidebarActive && "active"}`}>
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
              >
                <CloseIcon />
              </button>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24 flex items-center gap-2">
                 Customer Orders Management
                </h6>
                <ul className="max-h-540 overflow-y-auto scroll-sm">
                  {tabs
                    .filter((tab) => tab.condition)
                    .map((tab) => (
                      <li className="mb-24" key={tab.id}>
                        <a
                          href={`#${tab.id}`}
                          className={classNames(
                            "text-gray-900 hover-text-main-600 flex-align gap-8",
                            {
                              "text-main-600 font-semibold":
                                activeTab === tab.id,
                            }
                          )}
                          onClick={(e) => {
                            e.preventDefault();
                            if (tab.action) {
                              tab.action(); // 🔥 Trigger logout action
                            } else {
                              setActiveTab(tab.id);
                              setIsSidebarActive(false);
                            }
                          }}
                          style={{
                            outline:
                              activeTab === tab.id
                                ? "2px solid #EF6036"
                                : "none",
                            outlineOffset: "2px",
                          }}
                        >
                          {tab.icon} {tab.label}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          {/* Sidebar End */}

          {/* Content Start */}
          <div className="col-lg-9">
            {/* Mobile Toggle Button */}
            <div className="d-lg-none d-block mb-40">
              <button
                onClick={sidebarController}
                type="button"
                className="w-44 h-44 flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
              >
                <MenuIcon />
              </button>
            </div>

            {/* Main Content */}
            <div className="tab-content">
              {tabs.map(
                (tab) =>
                  tab.condition &&
                  tab.component && (
                    <div
                      key={tab.id}
                      className={classNames("tab-pane fade", {
                        "show active": activeTab === tab.id,
                      })}
                      id={tab.id}
                      role="tabpanel"
                    >
                      {tab.component}
                    </div>
                  )
              )}
            </div>
          </div>
          {/* Content End */}
        </div>
      </div>
    </section>
  );
};

export default OrderViewAmazonVendor;
